import { getSupportedTokensInternal } from "./get-supported-tokens-internal"
import { SupportedTokensRequest } from "./types"

/**
 * Query the Wido API and return a list of ERC-20 tokens that can be used for routing.
 */
export async function getSupportedTokens(request?: SupportedTokensRequest) {
  return await getSupportedTokensInternal(request)
}
